<script type="text/javascript">
	import {loginModal, registerModal, payModal} from "../modal/modal.js";
	import Icon from "../icon.svelte";
	export let user, mobile_menuOpened;
	import Lazy from 'svelte-lazy';

	user.updateUser_subscribe(u=>{user = u; console.log(user);});
</script>

<div class="app_header-user">
	{#if user && user.logged}
	
	<div class="user-centered">
		{#if window.innerWidth > 1015 || mobile_menuOpened}
		<Lazy height=150>
			<img class:verified={user.verified} src={user.ava} alt={user.name+' at TradeStore'}>
		</Lazy>
		{/if}
		<div class="user-control">
			<div class="user-name">
				<Icon user />
				<span class="user-name">{user.name}</span>
			</div>
			
			<button class="app_button-small"
					on:click={e=>user.logOut()}>Выйти</button>
		</div>
		<div class="user-balance">
			<span>Баланс: <strong>{user.balance} &#8381;</strong></span>
			<button class="app_button-primary" on:click={e=>payModal()}>
				<Icon plus w=17 h=17/>
			</button>
		</div>
	</div>

	{:else}
		<button class="app_button-primary app_button-wide" on:click={e=>loginModal()}>
			<Icon login/> <span>Авторизация</span></button>
		<button class="app_button-secondary app_button-wide" on:click={e=>registerModal()}>
			<Icon registr/> <span>Регистрация</span></button>
	{/if}
</div>

<style type="text/css">

	.user-balance{
		display: flex;
		justify-content: space-between;
		width: 100%;
		align-items: center;
		padding: 10px 15px;
		background: #1A202D;
		border-radius: 4px;
	}
	
	:global(body.svelte_widget .user-centered){
		padding:0!important;
	}

	.user-balance > span{
		font-size: 18px;
		line-height: 23px;
		color: rgba(255,255,255,.5);
	}
	.user-balance > span > strong{
		color: #AF71DC;
		font-weight: bold;
	}

	.user-balance > button{
		padding: 7px !important;
	}


	.user-centered{
		display: flex;
		flex-direction: column;
		align-items: center;padding: 0 20px;
	}
	.user-control{
		display: flex;
		align-items: center;
		margin-top: 17px;
		margin-bottom: 10px;
	}
	.user-control > .user-name > span{
		font-weight: bold;
		font-size: 18px;
		color: #E1E1E1;
	}
	.user-control > .user-name{
		display: flex;
		align-items: center;
		margin-right: 10px;
	}
	.user-control > div.user-name > span{
		margin-left: 5px;
	}

	.user-centered img{
		border-radius: 50%;
		width: 150px;
		height: 150px;
		object-fit: cover;
	}
	.user-centered img.verified{
		border: 4px solid #AA59E4;
		filter: drop-shadow(0px 0px 14px rgba(170, 89, 228, 0.74));
	}
	.app_header-user > button{
		width: 100%;
	}
	.app_header-user > button:not(:last-child){
		margin-bottom: 10px;
	}
	@media(max-width: 1015px){
		.app_header-user > button > span{
			display: none;
		}
		.app_header-user > button > svg{
			margin: 0 !important;
		}
		.app_header-user > button{
			margin-top: 0 !important;
			margin-bottom: 0 !important;
			min-width: 0 !important;
			width: auto !important;
		}
		.app_header-user > button:not(:last-child){
			margin-right: 10px !important;
		}
		.app_header-user{
			display: flex;
			align-content: center;
			align-items: center;
			justify-content: center;
			padding: 15px 15px;
			padding-bottom: 2px;
		}
	}
</style>